// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-progress{position:relative;height:.533vw;background:#ebedf0;border-radius:.533vw}.van-progress__portion{position:absolute;left:0;height:100%;background:#1989fa;border-radius:inherit}.van-progress__pivot{position:absolute;top:50%;box-sizing:border-box;min-width:3.6em;padding:0 .667vw;color:#fff;font-size:1.333vw;line-height:1.6;text-align:center;word-break:keep-all;background-color:#1989fa;border-radius:1em;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
